<template>
  <div class="container">
    <h1 class="py-4">加盟店端末マスタデータ</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="l-pid">企業ID</label><br />
          <input v-model="companyId" placeholder="企業ID" class="input-boot" />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">店舗ID</label><br />
          <input v-model="storeId" placeholder="店舗ID" class="input-boot" />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">端末ID</label><br />
          <input v-model="terminalId" placeholder="端末ID" class="input-boot" />
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary mr10" @click="clear">クリア</button>
        <button class="btn btn-primary" @click="search">検索</button>
      </div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.csvData"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
    </div>
    <div :key="key">
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="dataTable"
          :items="tableData"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #cell(端末ID)="data">
            <router-link
              :to="{
                name: 'MerchantTerminalDetails',
                query: { terminalId: data.item.端末ID },
              }"
              target="_blank"
              >{{ data.item.端末ID }}</router-link
            >
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="dataTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";
import prefs from "@/constants/PrefsEnum";
import countries from "@/constants/CountriesEnum";

export default {
  name: "Merchant",
  mixins: [utils, master, prefs, countries],
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  watch: {
    /*     currentPage(value) {
      sessionStorage.currentPage = value;
    }, */
  },
  data() {
    return {
      csvCurrentFields: {},
      currentPage: 1,
      perPage: 10,
      fileName: "",
      labels: [],
      loading: true,
      tableData: [],
      csvData: [],
      db: firebase.firestore(),
      companyId: "",
      terminalId: "",
      storeId: "",
      key: 0,
    };
  },
  components: {
    VueJsonToCsv,
  },
  created: function() {
    this.labels = this.tsvFormat.bankitInfo.labels;
    this.loadCollection();
  },
  methods: {
    init() {
      this.tableData = [];
      this.csvData = [];
      this.key = this.key ? 0 : 1;
    },
    clear() {
      this.terminalId = "";
      this.companyId = "";
      this.storeId = "";
      this.loadCollection();
    },
    search() {
      let searchParams = {
        company_id: this.companyId,
        terminal_id: this.terminalId,
        store_id: this.storeId,
      };
      this.loadCollection(searchParams);
    },
    loadCollection(searchParams = null) {
      this.init();
      let query = this.db.collection("merchantTerminals");
      if (searchParams !== null) {
        for (const [key, value] of Object.entries(searchParams)) {
          if (value !== "") {
            query = query.where(key, "==", value);
          }
        }
      }
      this.fileName = this.tsvFormat.merchantTerminalData.fileName;
      this.csvCurrentFields = this.tsvFormat.merchantTerminalData.labels;
      query
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              this.tableData.push({
                端末ID: data.terminal_id,
                企業ID: data.company_id,
                企業名: data.company_name.trim(),
                店舗ID: data.store_id,
                店舗名: data.store_name.trim(),
              });
              this.csvData.push(data);
            }
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
